export enum PhotogenyResultEnum {
  APPROVED = "approved",
  REJECTED = "rejected",
}

export const PhotogenyResultTranslate: Record<PhotogenyResultEnum, string> = {
  [PhotogenyResultEnum.APPROVED]: "Aprovado",
  [PhotogenyResultEnum.REJECTED]: "Reprovado",
};

export enum PhotogenyRejectionReasonEnum {
  NO_PROFILE = "NO_PROFILE",
  CRIED_TOO_MUCH = "CRIED_TOO_MUCH",
  MOVES_TOO_MUCH = "MOVES_TOO_MUCH",
}

export const PhotogenyRejectionReasonTranslate: Record<PhotogenyRejectionReasonEnum, string> = {
  [PhotogenyRejectionReasonEnum.NO_PROFILE]: "Sem perfil",
  [PhotogenyRejectionReasonEnum.CRIED_TOO_MUCH]: "Chorou muito",
  [PhotogenyRejectionReasonEnum.MOVES_TOO_MUCH]: "Se movimenta muito",
};
